import React, { Component } from 'react';
import PerPage from '../Shared/PerPage';

class FilteringSection extends Component {
  state = { query: this.props.q || '', searched: false };

  handleInput = (e) => {
    const query = e.target.value;
    this.setState({ query });

    if (this.state.searched && query === '') {
      window.location.reload();
    }
  };

  submitSearch = () => {
    const { onSearchChange } = this.props;
    const { query } = this.state;
    onSearchChange(this.state.query);
    this.setState({ searched: query.trim() !== '' });
  };

  render() {
    const {
      page: { page },
      pagesAmount,
      productsLog,
      tags,
      onModalOpen,
      onPageAmountChange,
      totalEntriesAmount,
      activePage,
      perPage,
      disableFilter,
    } = this.props;

    const inputCols = disableFilter ? 'col-12' : 'col-6';

    return (
      <div className="filter row pl-3 pr-3">
        <div className="filter-left-side col-12 col-lg-6 order-2 order-lg-1">
          {!productsLog && (
            <PerPage
              page={page}
              perPage={perPage}
              activePage={activePage}
              pagesAmount={pagesAmount}
              totalEntriesAmount={totalEntriesAmount}
              onPageAmountChange={onPageAmountChange}
            />
          )}
        </div>

        <div className="filter-right-side col-12 col-lg-6 pr-0 order-1 order-lg-2">
          <div className="row filter-left-side-search mr-0 w-100">
            <input
              type="text"
              className={`filter-left-side-search-field w-100 ${inputCols}`}
              placeholder={
                productsLog || tags ? 'Search' : 'Search in Furniture'
              }
              value={this.state.query}
              onChange={this.handleInput}
            />

            <button
              type="button"
              className="top-section-search-button"
              onClick={this.submitSearch}
            >
              SEARCH
            </button>

            {!disableFilter && (
              <button
                type="button"
                className="filter-right-side-button col-3"
                onClick={onModalOpen}
              >
                FILTER
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FilteringSection;
